import React from 'react';
import './PhotoViewer.css';

const PhotoViewer = ({ photos, onClose, onDelete }) => {
  if (!photos || photos.length === 0) {
    return null;
  }

  return (
    <div className="photo-viewer-container" onClick={onClose}>
      <div className="photo-viewer-content" onClick={(e) => e.stopPropagation()}>
        <div className="photo-viewer-header">
          <h3>Photos ({photos.length})</h3>
          <button className="close-button" onClick={onClose}>&times;</button>
        </div>
        
        <div className="photo-viewer-body">
          <div className="photo-grid">
            {photos.map((photo, index) => (
              <div key={index} className="photo-item">
                <img 
                  src={photo} 
                  alt={`Photo ${index + 1}`} 
                  className="photo-thumbnail"
                  onClick={() => {
                    // Open full size in new tab for now
                    window.open(photo, '_blank');
                  }}
                />
                <button 
                  className="delete-photo-button"
                  onClick={() => onDelete(index)}
                  title="Delete photo"
                >
                  ×
                </button>
              </div>
            ))}
          </div>
        </div>
      </div>
    </div>
  );
};

export default PhotoViewer; 